export default function ({ app, store }) {
    app.i18n.setLocale(store.getters.get_lang);

    app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
        store.commit('set_lang', newLocale);
    }
  }
